module.exports = __webpack_public_path__ + "img/legend-ob.5268a321.svg";